import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import ButtonUI from '../../widgets/action/ButtonUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PublicPageSF from '../../templates/PublicPageSF'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import SignUpWithPhoneSF from '../../components/public/SignUpWithPhoneSF'
import PhoneVerificationSF from '../../components/public/PhoneVerificationSF'
import SetPinCodeSF from '../../components/public/SetPinCodeSF'

const SignUpWithPhonePageUI = ({ context, messageList,
  // phone number
  phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
  // verification code
  verifCode, onVerifCodeChange, verifCodeError, setVerifCodeError,
  // pin code
  pinCode, onPinCodeChange, pinCodeError, setPinCodeError,
  // view
  view, setView }) =>
  <PublicPageSF context={context} className='pg_signup' backLink='/' centered={!messageList}
    messageList={messageList} headerMessageKey='c_sign_up'>
    {
      !messageList &&
      <SpinnerComponentUI />
    }
    {
      messageList && view === 'phoneNumber' &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true} backLink='/' messageList={messageList} titleMessageKey='c_sign_up' />

        <SignUpWithPhoneSF context={context} phoneNumber={phoneNumber}
          onPhoneNumberChange={onPhoneNumberChange} phoneNumberError={phoneNumberError}
          setPhoneNumberError={setPhoneNumberError} setView={setView} />

        <div className='g_text_center g_m_top_100'>
          <MessageUI messageList={messageList} messageKey='c_signup_agreeto_terms' />
        </div>
      </React.Fragment>
    }
    {
      messageList && view === 'verification' &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={false} messageList={messageList} titleMessageKey='c_verify_phone' />

        <PhoneVerificationSF context={context} phoneNumber={phoneNumber}
          onPhoneNumberChange={onPhoneNumberChange} phoneNumberError={phoneNumberError}
          setPhoneNumberError={setPhoneNumberError} verifCode={verifCode}
          onVerifCodeChange={onVerifCodeChange} verifCodeError={verifCodeError}
          setVerifCodeError={setVerifCodeError} setView={setView} />

        <div className='g_m_top_100'>
          <ButtonUI context={context} messageList={messageList} labelKey='c_re_signup'
            onClick={() => { setView('phoneNumber'); }} transparent={true}
          />
        </div>
      </React.Fragment>
    }
    {
      messageList && view === 'pinCode' &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={false} messageList={messageList} titleMessageKey='c_set_pin' />

        <SetPinCodeSF context={context} phoneNumber={phoneNumber}
          onPhoneNumberChange={onPhoneNumberChange} phoneNumberError={phoneNumberError}
          setPhoneNumberError={setPhoneNumberError} verifCode={verifCode}
          onVerifCodeChange={onVerifCodeChange} verifCodeError={verifCodeError}
          setVerifCodeError={setVerifCodeError} pinCode={pinCode}
          onPinCodeChange={onPinCodeChange} pinCodeError={pinCodeError}
          setPinCodeError={setPinCodeError} setView={setView} />
      </React.Fragment>
    }

  </PublicPageSF>

export default SignUpWithPhonePageUI
